import { SubscriptionPlanProductType, SubscriptionStatus } from '../graphql/api-platform-graphql';

/**
 * Subscription statuses that are considered active.
 * Includes Trial, Active, and Canceled (which remains active until end date).
 */
export const ACTIVE_SUBSCRIPTION_STATUSES = [SubscriptionStatus.Trial, SubscriptionStatus.Active, SubscriptionStatus.Canceled];

/**
 * Product types that represent Grow with Google subscription plans.
 */
export const GROW_WITH_GOOGLE_PRODUCT_TYPES = [SubscriptionPlanProductType.ConsumersubscriptionPlusGrowWithGoogle, SubscriptionPlanProductType.GrowWithGoogle];

/**
 * Product types that represent Value plan subscription plans.
 */
export const VALUE_PLAN_PRODUCT_TYPES = [SubscriptionPlanProductType.ConsumersubscriptionValuePlan];
//# sourceMappingURL=subscription-constants.js.map